import { Controller } from "@hotwired/stimulus";
import {
  formatPhoneNumber,
  formatPhoneNumberWithCountryCode,
} from "../formatters";

export default class extends Controller {
  static values = { invalidPhoneNumbers: Array };
  static targets = ["phone"];

  format(event) {
    formatPhoneNumber(event);
  }

  // For fields where numbers are commonly pasted with a country code, such as
  // the admin send-test and resend forms. `format` is left as-is for the many
  // fields already using it.
  formatWithCountryCode(event) {
    formatPhoneNumberWithCountryCode(event);
  }

  validate() {
    if (this.invalidPhoneNumbersValue.includes(this.phoneTarget.value)) {
      this.phoneTarget.setCustomValidity("This phone number is invalid.");
      this.phoneTarget.reportValidity();
    } else {
      this.phoneTarget.setCustomValidity("");
    }
  }
}
